
// DO NOT EDIT THIS FILE DIRECTLY. THIS FILE IS AUTO-GENERATED DURING BUILD TIME BY src/app/utils/configFetcher/original/configServerFetcher.ts
// To change the values in this file, update the configuration in the configuration server.

// Generated on 2026-11-02T19:20:41.388Z

import { FrontendConfigAndConfigId } from '@med_poc/types/dist/config/frontendConfig';


export const environment: FrontendConfigAndConfigId = {
  "production": false,
  "apiUrl": "https://api.dev.santea.lu/",
  "apiUrlMaster": "https://api.dev.santea.lu/",
  "projectName": "SANTEA Human Health",
  "baseUrl": "https://www.dev.santea.lu/",
  "nameLabel": "master",
  "gatewayFrontend": "https://www.dev.santea.lu/",
  "letterTemplateUrl": "./assets/docs/letterTemplate.docx",
  "environmentType": "dev",
  "gcloudMapsPublicApiKey": "AIzaSyD5WNj8qXhVAEA9J44eLemDMd6ec1QyCQI",
  "OIDC_LOGIN_URL": "https://www-integration.esante.lu/auth/realms/default/protocol/openid-connect/auth",
  "childOrMasterOrGateway": "master",
  "OIDC_CLIENT_ID": "eConnector-SaaS-SIMS_SOLUTIONS",
  "OIDC_REDIRECT_URI": "https://www.dev.santea.lu/callbacks/oidc",
  "configID": "d017bb9f-d942-41ea-858c-fdb1a8dd5a79-dev",
  "typesVersion": "^23.2.3",
  "urlSuffix": "./assets/i18n/"
};
